import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import AddStudentModal from "./AddStudentModal";
import SubmitAttendanceModal from './SubmitAttendanceModal';
import moment from "moment";
import './_attendance.scss';
import HolidayModal from './holidayModal';
import AttendanceNotificationModal from './NotificationModal'

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const ADD_HOLIDAY = gql`
  mutation($params: AddHoliday) {
    addHolidays(params: $params)
  }
`;

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
        class_id
      }
      educationalClasses {
        id
        class
      }
    }
  }
`;


class StudentAttendanceHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BreadcrumbData: {
                Title: "STUDENT ATTENDANCE",
                btnName: "Add Student"
            },

            currentStep: 1,
            branch: "",
            section: "",
            class: "",
            exam: "",
            attendance: "",
            submitError: "",
            BranchesSection: {
                Title: "Students",
                btnName: "Add Student",
            },
            tableHeaderData: {
                Title: "Students",
            },
            attendance_status: 0,
            attendanceSearch: 0,

            attendanceSearchval: "",
            classSearch: "0",
            examSearch: "0",
            classSearchval: "",
            examSearchval: "",
            sectionSearch: "0",
            sectionSearchval: "",
            branchSearch: "0",
            branchSearchval: "",
            loadingSpinner: 0,
            classError: "",
            examError: "",
            branchError: "",
            attendanceError: "",
            sectionError: "",
            getEducationalStudents: [],
            startDateCalender: "",
            endDateCalender: "",
            modalShow: false,
            modalShow1: false,
            totalStudents: 0,
            no_of_present: 0,
            no_of_absent: 0,
            no_of_sick: 0,
            date: new Date().toISOString().slice(0, 10),
            currentDate: new Date().toISOString().slice(0, 10),

            holidayModal: false,
            notifyModal: false,
            notifyLoader: 0,
            getAbsentStudentsData: [],
            holidayBranch: "",
            holidayBranchVal: "",
            holidayBranchError: "",
            attendance_types: [],
            getExams: [],
            getClasses: [],
            getSections: [],
            submitted: false,
            status: "",
            search: "",
            currentPageStartCount: 0,
            currentPageEndCount: 10
        };
    }

    dropDownGetValues(fieldname, value) {
        let getArray = [];

        // if(fieldname != "branchSearch"){
        //     const newObj1 = {
        //         value: "0",
        //         label: "Select"
        //     }
        //     getArray.push(newObj1);

        // }

        if (fieldname == "classSearch") {

            let uniqueClasses = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == value).map((item1) => item1.class_id))].sort();

            uniqueClasses.map((val) => {
                let individualClassData = this.props.globals.globals.educationalClasses.find((item1) => item1.id == val);
                const newObj = {
                    value: individualClassData.id,
                    label: individualClassData.class
                }
                getArray.push(newObj);
            })

            this.setState({ getClasses: getArray })

        }
        else if (fieldname == "examSearch") {
            let uniqueExams = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getArray.push(newObj);
            })

            this.setState({ getExams: getArray })
        }
        else if (fieldname == "sectionSearch") {

            let uniqueSections = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == this.state.examSearch && item.class_id == value).map((item1) => item1.section_id))].sort();

            uniqueSections.map((val) => {
                let individualSectionData = this.props.globals.globals.globalSections.find((item1) => item1.id == val);
                const newObj = {
                    value: individualSectionData.id,
                    label: individualSectionData.section_name
                }
                getArray.push(newObj);
            })

            this.setState({ getSections: getArray })
        }
        else if (fieldname == "branchSearch") {
            let uniqueBranches = [...new Set(this.props.globals.globals.b_e_c_s_data.map((item) => item.branch_id))];
            uniqueBranches.map((val) => {
                let individualBranchData = this.props.globals.globals.globalBranches.find((item1) => item1.id == val);
                const newObj = {
                    value: individualBranchData.id,
                    label: individualBranchData.branch_name
                }
                getArray.push(newObj);
            })
        }
        return getArray;
    }

    submit = () => {
        this.setState({
            getEducationalStudents: [],
            classSearchval: {
                value: "0",
                label: "Select"
            },
            class: "",
            examSearchval: {
                value: "0",
                label: "Select"
            },
            exam: "",
            sectionSearchval: {
                value: "0",
                label: "Select"
            },
            section: "",
            branchSearchval: {
                value: "0",
                label: "Select"
            },
            branch: "",
            attendanceSearchval: {
                value: "0",
                label: "Select"
            },
            attendance: "",
            date: new Date().toISOString().slice(0, 10),
        })
    }

    selecthandleInputChange = (ename, evalue) => {
        const name = ename;
        const value = evalue;

        //class
        if (name == "classSearch") {
            if (value != "0") {
                let classSearchData = this.props.globals.globals.educationalClasses.find((a) => a.id == value);
                this.setState({
                    classSearchval: {
                        value: classSearchData.id,
                        label: classSearchData.class
                    },
                    class: classSearchData.class,
                    classError: "",
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendanceSearchval: "",
                    attendance: "",
                    section: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getSections: [],
                    attendanceError: "",
                    sectionError: "",
                    submitted: false,
                    search: "",

                });

                this.dropDownGetValues('sectionSearch', value);

            } else {
                this.setState({
                    classSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendanceSearchval: "",
                    attendance: "",
                    class: "",
                    section: "",
                    classSearchval: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getClasses: [],
                    getSections: [],
                    classError: "",
                    attendanceError: "",
                    sectionError: "",
                    submitted: false,
                    search: "",

                });
            }
        }

        if (name == "examSearch") {
            if (value != "0") {
                let examSearchData = this.props.globals.globals.exams.find((a) => a.id == value);
                this.setState({
                    examSearchval: {
                        value: examSearchData.id,
                        label: examSearchData.exam
                    },
                    exam: examSearchData.exam,
                    sectionSearch: "0",
                    sectionSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendanceSearchval: "",
                    attendance: "",
                    class: "",
                    section: "",
                    classSearchval: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getClasses: [],
                    getSections: [],
                    classError: "",
                    attendanceError: "",
                    sectionError: "",
                    examError: "",
                    submitted: false,
                    search: "",
                });

                this.dropDownGetValues('classSearch', value)



            } else {
                this.setState({
                    examSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    getEducationalStudents: [],
                    attendance_types: [],
                    attendanceSearchval: "",
                    attendance: "",
                    class: "",
                    section: "",
                    classSearchval: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getClasses: [],
                    getSections: [],
                    classError: "",
                    attendanceError: "",
                    sectionError: "",
                    examError: "",
                    exam: "",
                    submitted: false,
                    search: "",
                });
            }
        }
        //section
        if (name == "sectionSearch") {
            if (value != "0") {

                let sectionSearchData = this.props.globals.globals.globalSections.find((a) => a.id == value);

                this.setState({
                    sectionSearchval: {
                        value: sectionSearchData.id,
                        label: sectionSearchData.section_name
                    },
                    section: sectionSearchData.section_name,
                    sectionError: "",
                    getEducationalStudents: [],
                    submitted: false,
                    search: "",

                });

                this.getAttendanceTypes(this.state.examSearch);
            } else {
                this.setState({
                    sectionSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    section: "",
                    sectionError: "",
                    getEducationalStudents: [],
                    attendanceError: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    submitted: false,
                    search: "",
                });
            }
        }

        //branch
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globals.globalBranches.find((a) => a.id == value);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branch: branchSearchData.branch_name,
                    branchError: "",
                    getEducationalStudents: [],
                    exam: "",
                    class: "",
                    section: "",
                    attendance: "",
                    examSearchval: "",
                    classSearchval: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    classError: "",
                    examError: "",
                    attendanceError: "",
                    sectionError: "",
                    examSearch: "",
                    submitted: false,
                    search: "",
                });
                this.dropDownGetValues('examSearch', value)

            } else {
                this.setState({
                    branchSearchval: {
                        value: "0",
                        label: "Select"
                    },
                    branch: "",
                    getEducationalStudents: [],
                    exam: "",
                    class: "",
                    section: "",
                    attendance: "",
                    examSearchval: "",
                    classSearchval: "",
                    sectionSearchval: "",
                    attendanceSearchval: "",
                    attendance_types: [],
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    classError: "",
                    examError: "",
                    attendanceError: "",
                    sectionError: "",
                    examSearch: "",
                    branchSearch: "",
                    submitted: false,
                    search: "",
                });
            }
        }

        if (name == "holidayBranch") {
            console.log("values", value, name);
            if (value != "0") {
                let branchSearchData = this.props.globals.globals.globalBranches.find((a) => a.id == value);
                console.log("brrrrr", branchSearchData);
                this.setState({
                    holidayBranchVal: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    holidayBranchError: "",
                });
            } else {
                this.setState({
                    holidayBranchVal: {
                        value: "0",
                        label: "Select"
                    },
                });
            }
        }

        //attendance Types

        if (name == "attendanceType") {

            let attendanceSearchData = this.state.attendance_types.find((a) => a.value == value);
            console.log("this.state.attendance_types", attendanceSearchData);
            this.setState({
                attendanceSearchval: {
                    value: attendanceSearchData.value,
                    label: attendanceSearchData.label
                },
                attendance: attendanceSearchData.attendance_subtype,
                attendanceError: "",
                getEducationalStudents: [],
                submitted: false,
                search: "",

            });

        }


        this.setState({ [name]: value });
    }



    getAttendanceTypes = async (val) => {
        const result = await this.props.client.query({
            query: gql` 
           query($institution_id: Int,$exam_id:Int,$branch_id:Int
               ) {
                getAttendanceTypes(institution_id: $institution_id,exam_id:$exam_id,branch_id:$branch_id) {
                    id
                    attendance_subtype
                }
           }
       `,
            variables: {
                exam_id: parseInt(val),
                institution_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearch)
            },
            fetchPolicy: 'network-only'
        });

        if (result.data.getAttendanceTypes != undefined) {
            let data = [];
            result.data.getAttendanceTypes.map((item) => {
                data.push({ value: item.id, label: item.attendance_subtype })
            })
            this.setState({
                attendance_types: data
            });
        }
    };

    handleFormSubmit = e => {

        console.log("this.state.StudentsFilterData", this.state.StudentsFilterData);

        if (this.state.branch === "") {
            this.setState({ branchError: "Please select branch" });
            return ""
        }

        if (this.state.exam === "") {
            this.setState({ examError: "Please select exam" });
            return ""
        }

        if (this.state.class === "") {
            this.setState({ classError: "Please select class" });
            return ""
        }



        if (this.state.section === "") {
            this.setState({ sectionError: "Please select section" });
            return ""
        }


        if (this.state.attendance === "") {
            this.setState({ attendanceError: "Please select attendance Type" });
            return ""
        }

        e.preventDefault();

        this.setState({
            loader: 1
        });

        this.getEducationalStudents();
    };

    getEducationalStudents = async () => {
        const result = await this.props.client.query({
            query: gql` 
           query(
            $institution_id: Int!,$class_id:Int,$section_id:Int,$branch_id:Int,$exam_id:Int,$type_id:Int,$selected_date:String
               ) {
                getEducationalStudents(institution_id: $institution_id,section_id:$section_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,type_id:$type_id,selected_date:$selected_date) {
                    student_name
                    student_mobile
                    roll_no
                    exam_id
                    class_id
                    branch_id
                    section_id
                    attendance_status  
               }
           }
       `,
            variables: {
                exam_id: parseInt(this.state.examSearchval.value),
                institution_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearchval.value),
                class_id: parseInt(this.state.classSearchval.value),
                section_id: parseInt(this.state.sectionSearchval.value),
                type_id: parseInt(this.state.attendanceSearchval.value),
                selected_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            },
            fetchPolicy: 'network-only'
        });

        if (result.data.getEducationalStudents != undefined) {
            let data = [];
            result.data.getEducationalStudents.sort((a, b) => a.attendance_status - b.attendance_status).map((item) => {
                let label = "Present";
                if (parseInt(item.attendance_status) == 1) {
                    label = "Present"
                } else if (parseInt(item.attendance_status) == 0) {
                    label = "Absent"
                } else if (parseInt(item.attendance_status) == 3) {
                    label = "Sick"
                }
                data.push({ ...item, value: parseInt(item.attendance_status), label })
            })

            let totalStudents = data.length;
            let no_of_present = data.filter((item) => parseInt(item.value) == 1).length;
            let no_of_absent = data.filter((item) => parseInt(item.value) == 0).length;
            let no_of_sick = data.filter((item) => parseInt(item.value) == 3).length;

            this.setState({
                getEducationalStudents: data,
                loader: 0,
                totalStudents: totalStudents,
                no_of_present: no_of_present,
                no_of_absent,
                no_of_sick,
                submitted: true,
                currentPageStartCount: 0,
                currentPageEndCount: 10,
                search: "",
            });
        }
    };

    tableData = (savedPapersData) => {
        let getArray = [];

        savedPapersData.map(item => {
            let class_name = "";
            let branch_name = "";
            let exam_name = "";
            let section_name = "";

            this.props.globals.globals.classes.map((stumap) => {
                if (stumap.id == item.class_id) {
                    class_name = stumap.class
                }
            });

            this.props.globals.globals.globalBranches.map((stumap) => {
                if (stumap.id == item.branch_id) {
                    branch_name = stumap.branch_name
                }
            });

            this.props.globals.globals.exams.map((stumap) => {
                if (stumap.id == item.exam_id) {
                    exam_name = stumap.exam
                }
            });

            this.props.globals.globals.globalSections.map((stumap1) => {
                if (stumap1.id == item.section_id) {
                    section_name = stumap1.section_name
                }
            })

            const newObject = {
                student_name: item.student_name,
                student_rollno: item.roll_no,
                student_mobile: item.student_mobile,
                class_name: class_name,
                branch_name: branch_name,
                exam_name: exam_name,
                section_name: section_name,
                attendance_status: item.attendance_status
            }
            getArray.push(newObject);
        })

        return getArray;
    }

    presentOrAbsent = (e, row) => {
        console.log("rowdddddd", e);

        let educationalStudents = [];

        educationalStudents = this.state.getEducationalStudents.map((item) => {
            if (item.student_mobile == row.student_mobile) {
                if (e.target.value == 1) {
                    return { ...item, value: 1, label: "Present" }
                }
                else if (e.target.value == 0) {
                    return { ...item, value: 0, label: "Absent" }
                }
                else {
                    return { ...item, value: 3, label: "Sick" }
                }
            } else {
                return { ...item }
            }
        })


        console.log("educationalStudents", educationalStudents);


        let totalStudents = this.state.getEducationalStudents.length;
        let no_of_present = educationalStudents.filter((item) => item.value == 1).length;
        let no_of_absent = educationalStudents.filter((item) => item.value == 0).length;
        let no_of_sick = educationalStudents.filter((item) => item.value == 3).length;

        this.setState({ getEducationalStudents: educationalStudents, totalStudents: totalStudents, no_of_present: no_of_present, no_of_absent, no_of_sick });

    }

    present = (row, rowIndex, formatExtraData) => {
        let attendance_status = [{ value: 1, label: "Present" }, { value: 0, label: "Absent" }];
        let attendedStatus = this.state.getEducationalStudents.filter((item) => item.student_mobile == row.student_mobile)
        console.log("attendedStatus", attendedStatus);
        this.setState({ status: "" })
        return (
            <>
                <select class="form-control" onChange={(e) => { this.presentOrAbsent(e, row) }}>
                    {
                        attendance_status.map((item) => {
                            if (item.value == attendedStatus[0].value) {
                                return <option value={item.value} selected >{item.label}</option>
                            } else {
                                return <option value={item.value}>{item.label}</option>
                            }
                        })
                    }
                </select>
            </>
        )
    }

    articlecolumns = [
        {
            dataField: "student_rollno",
            text: "Student Roll no",
        },
        {
            dataField: "student_name",
            text: "Student Name",
        },
        {
            dataField: "student_mobile",
            text: "Student Mobile",
        },
        {
            dataField: "branch_name",
            text: "Branch",
        },
        {
            dataField: "exam_name",
            text: "Exam",
        },
        {
            dataField: "class_name",
            text: "Class",
        },
        {
            dataField: "section_name",
            text: "Section",
        },
        {
            dataField: "attendance_status",
            text: "Attendance Status",
            formatter: this.present.bind(this)
        },

    ];

    applyCallback = (startDate, endDate) => {
        this.setState({
            startDateCalender: startDate.unix(),
            endDateCalender: endDate.unix()
        })
    }

    selDate = (e) => {
        this.setState({ date: e.target.value, getEducationalStudents: [], submitted: false })
    }

    openHolidayModal = () => {
        this.setState({ holidayModal: true })

    }

    markHoliday = async () => {

        if (this.state.holidayBranch == "" || this.state.holidayBranch == "0") {
            this.setState({
                holidayBranchError
                    :
                    "Please Select Branch"
            });
            return ""
        }

        let params = {
            holiday_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.holidayBranch)
        }

        this.addHolidays(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            setTimeout(() => {
                this.SetpageLoad();

            }, 2000);
        })
    }

    addHolidays = async params => {
        await this.props.addHolidays({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addHolidays) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0, holidayModal: false });
        window.location.reload(false);
    };

    openSendNotificationModal = async () => {
        this.setState({ notifyModal: true, notifyLoader: 1 })

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$date:String $section_id:Int,$attendance_subtype_id:Int){
                getAbsentStudentsData(institute_id:$institute_id,branch_id:$branch_id,date:$date ,section_id:$section_id,attendance_subtype_id:$attendance_subtype_id){
                    student_name
                    parent_mobile
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearchval.value),
                section_id: parseInt(this.state.sectionSearchval.value),
                date: moment(this.state.date, 'YYYY-MM-DD').unix().toString(),
                attendance_subtype_id: parseInt(this.state.attendanceSearchval.value)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getAbsentStudentsData.length > 0) {
            this.setState({
                getAbsentStudentsData: result.data.getAbsentStudentsData,
                notifyLoader: 0
            })
        } else {
            this.setState({
                getAbsentStudentsData: [],
                notifyLoader: 0
            })
        }
    }

    searchFilter = (e) => {
        let value = e.target.value
        console.log("e", value);
        this.setState({ search: value, currentPageStartCount: 0, currentPageEndCount: 10 })
    }


    pageChange = (pageNumber) => {
        console.log("pageNumber", pageNumber);
        this.setState({
            currentPageStartCount: (+pageNumber - 1) * 10,
            currentPageEndCount: +pageNumber * 10
        })
    }

    clearAttendanceData = () => {
        this.setState({ getEducationalStudents: [], submitted: false })
    }

    render() {
        
        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        let filterStudentData = this.state.getEducationalStudents;

        if (this.state.search != "") {
            filterStudentData = this.state.getEducationalStudents.filter((item) => item.student_mobile.includes(this.state.search) || item.student_name.toLowerCase().includes(this.state.search.toLocaleLowerCase()) || item.roll_no.includes(this.state.search))
        }

        console.log("globals123", this.state);

        if (loading1) {
            return (
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className="spinner-border  text-center loading-img-center"></div>
                        </Col >
                    </Row>
                </Container >
            )
        }

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }



        let startNumber = 0
        let endNumber = filterStudentData.length;


        let pages = Math.ceil(endNumber / 10);

        let pagewiseFilterData = filterStudentData.filter((item, index) => index >= this.state.currentPageStartCount && index < this.state.currentPageEndCount);



        console.log("pages", startNumber, endNumber, pages);

        return (
            <section className="students_section">
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">STUDENT ATTENDANCE</h2>
                            <div className="filter-block d-flex align-items-center mr-4">
                                <input type="date" className="date" value={this.state.date} onChange={this.selDate} max={this.state.currentDate} />
                            </div>
                        </div>
                    </Col>

                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme d-flex">
                            <h6 className="">If you want to mark today as holiday please click the button</h6>
                            <button className="text-uppercase report_btn mb-2 ml-3" onClick={(e) => this.openHolidayModal()} >Mark Holiday </button>
                        </div>
                    </Col>

                    <Col xl={12} lg={12} md={12} sm={12} className="studentTable mt-5">
                        <Row>
                            <Col lg={2} md={12} sm={12}>
                                <h6>Branch </h6>
                                <SelectDropDown
                                    stateData={this.state.branchSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="branchSearch"
                                    options={this.dropDownGetValues("branchSearch")}
                                    placeholderName={'Branch'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                                <span className="text-danger f-16">{this.state.branchError}</span>
                            </Col>

                            <Col lg={2} md={12} sm={12}>
                                <h6>Exam </h6>
                                <SelectDropDown
                                    stateData={this.state.examSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="examSearch"
                                    options={this.state.getExams}
                                    placeholderName={'Exam'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                                <span className="text-danger f-16">{this.state.examError}</span>
                            </Col>


                            <Col lg={2} md={12} sm={12}>
                                <h6>Class </h6>
                                <SelectDropDown
                                    stateData={this.state.classSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="classSearch"
                                    options={this.state.getClasses}
                                    placeholderName={'Class'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                                <span className="text-danger f-16">{this.state.classError}</span>
                            </Col>

                            <Col lg={2} md={12} sm={12}>
                                <h6>Section </h6>
                                <SelectDropDown
                                    stateData={this.state.sectionSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="sectionSearch"
                                    options={this.state.getSections}
                                    placeholderName={'Section'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                                <span className="text-danger f-16">{this.state.sectionError}</span>
                            </Col>

                            <Col lg={2} md={12} sm={12}>
                                <h6>Attendance Type </h6>
                                <SelectDropDown
                                    stateData={this.state.attendanceSearchval}
                                    handleChange={this.selecthandleInputChange}
                                    name="attendanceType"
                                    options={this.state.attendance_types}
                                    placeholderName={'Attendance Type'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                                <span className="text-danger f-16">{this.state.attendanceError}</span>
                            </Col>

                            <Col lg={2} md={12} sm={12}>
                                <Button className="text-uppercase get_btn mt-4" onClick={this.handleFormSubmit}>Get Students</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {
                    this.state.getEducationalStudents.length > 0 ?
                        (
                            <>
                                <Row className="mt-5">
                                    <Col sm={3}>
                                        <h5>Want to Notify Parents ?</h5>
                                    </Col>

                                    <Col sm={4}>
                                        <Button className="report_btn" onClick={() => this.openSendNotificationModal()}>SEND NOTIFICATION</Button>
                                    </Col>
                                </Row>
                                <Row  >
                                    <Col sm={12}>
                                        <h6 className="text-center text-danger res_view">Note: By default all students are marked as present. Change to mark as absent/sick</h6>
                                    </Col>
                                </Row>


                                <Row>
                                    <Col lg={3} md={3} sm={12}>
                                        <Form.Group as={Col} controlId="formSearch">
                                            <Form.Control type="text" placeholder="Search" name='search' onChange={(e) => this.searchFilter(e)} />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col sm={12}>
                                        <div className="attendance_table">

                                            <Table striped bordered hover className="text-center attendance_table">
                                                <thead>
                                                    <tr>
                                                        <th>Student Roll NO</th>
                                                        <th>Student Name</th>
                                                        <th>Student Mobile</th>
                                                        {/* <th>Branch</th> */}
                                                        <th>Exam</th>
                                                        <th>Class</th>
                                                        <th>Section</th>
                                                        <th>Attendance Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        pagewiseFilterData.map((item) => {

                                                            console.log("item1234", item);
                                                            let class_name = "";
                                                            let branch_name = "";
                                                            let exam_name = "";
                                                            let section_name = "";

                                                            this.props.globals.globals.classes.map((stumap) => {
                                                                if (stumap.id == item.class_id) {
                                                                    class_name = stumap.class
                                                                }
                                                            });

                                                            this.props.globals.globals.globalBranches.map((stumap) => {
                                                                if (stumap.id == item.branch_id) {
                                                                    branch_name = stumap.branch_name
                                                                }
                                                            });

                                                            this.props.globals.globals.exams.map((stumap) => {
                                                                if (stumap.id == item.exam_id) {
                                                                    exam_name = stumap.exam
                                                                }
                                                            });

                                                            this.props.globals.globals.globalSections.map((stumap1) => {
                                                                if (stumap1.id == item.section_id) {
                                                                    section_name = stumap1.section_name
                                                                }
                                                            })
                                                            let attendance_status = [{ value: 1, label: "Present" }, { value: 0, label: "Absent" }];

                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <td>{item.roll_no}</td>
                                                                        <td>{item.student_name}</td>
                                                                        <td>{item.student_mobile}</td>
                                                                        {/* <td>{branch_name}</td> */}
                                                                        <td>{exam_name}</td>
                                                                        <td>{class_name}</td>
                                                                        <td>{section_name}</td>
                                                                        <td>
                                                                            <select className={item.value == 0 ? "selectWithColor" : "selectWithOutColor"} onChange={(e) => { this.presentOrAbsent(e, item) }}  >
                                                                                {
                                                                                    attendance_status.map((item1) => {
                                                                                        if (item1.value == item.value) {
                                                                                            return <option value={item1.value} selected   >{item1.label}</option>
                                                                                        } else {
                                                                                            return <option value={item1.value}  >{item1.label}</option>
                                                                                        }
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                    }
                                                </tbody>

                                            </Table>
                                        </div>
                                        <Row>
                                            <Col className="d-flex justify-content-start mr-3 mb-3">
                                                {
                                                    Array.from({ length: pages }, (_, index) => {
                                                        return (
                                                            <p className={this.state.currentPageStartCount / 10 == index ? "ml-2 pageIndex active" : "ml-1 pageIndex"} onClick={() => this.pageChange(index + 1)}>{index + 1}</p>
                                                        )
                                                    })
                                                }
                                            </Col>
                                            <Col >
                                                <div className="filter-block d-flex align-items-center justify-content-end mr-4 mt-3">
                                                <Button className="get_btn" onClick={() => this.setState({ modalShow1: true })}>SUBMIT ATTENDANCE</Button>

                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        )
                        :
                        (
                            <Container>
                                <Row>
                                    <Col sm={12}>
                                        <div className={this.state.loader == 1 ? "d-flex align-items-center spinner-border  text-center loading-img-center mt-5" : ""}  style={{color:"#213046"}} >
                                            {
                                                this.state.submitted == true && this.state.loader == 0 && this.state.getEducationalStudents.length == 0 ? (
                                                    <h6 className="d-flex justify-content-center align-items-center mt-5">No students available</h6>
                                                ) : ("")
                                            }
                                        </div>
                                    </Col >
                                </Row>
                            </Container >
                        )
                }

                <AddStudentModal
                    stateData={this.state}
                    globals={globals.globals}
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                />

                <SubmitAttendanceModal
                    stateData={this.state}
                    show={this.state.modalShow1}
                    onHide={() => this.setState({ modalShow1: false })}
                    onsubmit={() => this.submit()}
                    clearAttendanceData={() => this.clearAttendanceData()}

                />
                <HolidayModal
                    show={this.state.holidayModal}
                    onHide={() => this.setState({
                        holidayModal: false, holidayBranchError: "", holidayBranch: "",
                        holidayBranchVal: "",
                        holidayBranchError: "",
                        submitted: false
                    })}
                    markHoliday={this.markHoliday}
                    stateData={this.state}
                    globals={globals.globals}
                    selecthandleInputChange={this.selecthandleInputChange}
                />

                <AttendanceNotificationModal
                    show={this.state.notifyModal}
                    onHide={() => this.setState({
                        notifyModal: false, submitted: false
                    })}
                    stateData={this.state}
                    onsubmit={() => this.submit()}
                />
            </section >
        );
    }
}


export default withRouter(withApollo(
    compose(
        graphql(FETCH_GLOBALS, {
            options: (props) => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid")),
                },
            }),
            name: "globals",
        }),
        graphql(ADD_HOLIDAY, {
            name: "addHolidays"
        })

    )(StudentAttendanceHome))
);
